export default __webpack_public_path__ + "static/media/WWIC.2e904b10.png";